import {getCardInterestType} from '@web/slices/admissionDetail/slice'
import makeSlice from '@web/slices/admissionDetail/sliceMaker'

import {initResult} from '../../actions/familyPay'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initResult.fulfilled, (state, {payload}) => {
            const {pay} = payload

            if (pay) {
                const {payAdmission} = pay

                state.pay.chargePointPayAmount = pay.chargePointPayAmount
                state.pay.rewardPointPayAmount = pay.rewardPointPayAmount
                state.pay.generalPayAmount = pay.generalPayAmount

                /**
                 * partFreeInterestBurdenMonths 가 빈스트링이 아니면 부분무이자로 판단한다.
                 * 승인 당시에는 몇개월 부분무이자인지 알 수 없어 정확한 개월수를 BE도 알 수 없음
                 * see) https://oss.fin.navercorp.com/Product-Planning/Order_QA/issues/10603#issuecomment-1811785
                 */
                const isPartFreeInterest =
                    (payAdmission?.freeInterestInstallmentInfo?.partFreeInterestBurdenMonths ?? '').length > 0

                const interestType = getCardInterestType({
                    freeInterestInstallment:
                        payAdmission?.freeInterestInstallmentInfo?.freeInterestInstallmentApply ?? false,
                    partFreeInterestInstallment: isPartFreeInterest,
                })

                state.usedPaymentMethod = {
                    ...(payAdmission?.payMethodType === 'CARD_EASY_PAY'
                        ? {
                              card: {
                                  companyName: payAdmission.cardSettleInfo?.cardCompanyName ?? '',
                                  installment: {
                                      interestType,
                                      month: payAdmission.freeInterestInstallmentInfo?.installmentMonth ?? 0,
                                  },
                                  maskedNumber: payAdmission.cardSettleInfo?.maskedCardNumber ?? '',
                              },
                          }
                        : {}),
                }
            }
        })
    },
})

export default slice.reducer
